export default __webpack_public_path__ + "static/media/4.42c3faa5.png";